import SystemConst from '@/shared/system-const';
import axios from 'axios';

export default {
    namespaced: true,

    actions: {
        // アップロードファイルの最大サイズとアップロードファイルの選択可能な拡張子の取得API
        async getParameters() {
            // result の初期化
            let result: any;

            // パラメータ情報をback側から取得
            await axios.get('/api/personnel-change/parameters')
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // アップロードファイルチェックAPI
        async check({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // ファイルをback側へアップロードして内部データをチェック
            await axios.post('/api/personnel-change/check', data.formData)
                .then((response) => {
                    // 通信結果を設定
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 人事異動変換チェック結果一覧のフィルター情報取得API
        async getFilterConditions() {
            // resultの初期化
            let result: any;

            await axios.get('/api/personnel-change/filter-conditions')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // チェック結果一覧取得API
        async getResults({ state, commit, rootState }: any, data: any) {
            // resultの初期化
            let result: any;

            // back側からチェック結果データを取得
            // 通信：get
            // パス：/api/personnel-change/results
            // パラメータ：ページ番号
            //             １ページあたりの行数
            //             ソートキー
            //             ソート順
            //             フィルタ情報
            await axios.get('/api/personnel-change/results', {
                params: {
                    page: data.page,
                    itemsPerPage: data.itemsPerPage,
                    sortKey : data.sortKey,
                    sortOrder : data.sortOrder,
                    filterParams : data.filterParams
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 一括登録ファイル作成API
        async createBulkFile({ state, commit, rootState }: any) {
            // resultの初期化
            let result: any;

            // back側で一括登録ファイルを作成
            // 通信：post
            // パス：/api/personnel-change/create-files
            // パラメータ：なし
            await axios.post('/api/personnel-change/create-files')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 人事異動変換チェック結果一覧のExcelファイルダウンロードAPI
        async outputExcelFile({ state, commit, rootState }: any, data: any) {
            // ファイル名の格納
            const fileName = SystemConst.PERSONNEL_CHANGE_EXCEL_FILE_NAME;

            // resultの初期化
            let result: any;

            // URL:GET /api/personnel-change/excel-output
            // パラメータ：sortKey
            //             sortOrder
            //             filterParams
            await axios.get('/api/personnel-change/excel-output',
            {
                params: {
                    sortKey: data.sortKey,
                    sortOrder: data.sortOrder,
                    filterParams: data.filterParams,
                },
                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
            .then((response) => {
                // 通信結果を設定（正常）
                result = response;

                // レスポンス結果のバイナリデータが存在する場合、ファイルを作成する
                if (response.data) {
                    // レスポンス結果のバイナリデータをBlobオブジェクトにする
                    const blob = new Blob([response.data]);

                    // BlobオブジェクトのURLオブジェクトを作成する
                    const objURL: string = window.URL.createObjectURL(blob);

                    // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                    const dlLink: HTMLAnchorElement = document.createElement('a');
                    dlLink.href = objURL;
                    dlLink.download = fileName;

                    // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                    document.body.appendChild(dlLink);

                    // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                    dlLink.click();

                    // 子ノードを削除する
                    document.body.removeChild(dlLink);
                }
            })
            .catch((error) => {
                // 通信結果を設定（エラー）
                result = error.response;

                // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                const errorMessage = Array.from(new Uint8Array(error.response.data));

                // 作成した文字コードを文字列に変換し、JSON形式に変換する
                result.data =  JSON.parse(String.fromCharCode.apply('', errorMessage));
            });

            // 通信結果を返す
            return result;
        },

        // ファイルサイズ情報取得API
        async getBulkFileSize({ state, commit, rootState }: any) {
            // resultの初期化
            let result: any;

            // back側から一括登録ファイルのファイルサイズ情報を取得する
            // 通信：get
            // パス：/api/personnel-change/get-file-size
            await axios.get('/api/personnel-change/get-file-size')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 一括登録ファイルダウンロードAPI
        async bulkFileDownload({ state, commit, rootState }: any) {
            // ファイル名の格納
            const fileName = SystemConst.PERSONNEL_CHANGE_BULK_FILE_NAME;

            // resultの初期化
            let result: any;

            // URL:GET /api/personnel-change/file-download
            // パラメータ：なし
            await axios.get('/api/personnel-change/file-download',
            {
                // レスポンスのバイナリデータをarraybufferで受け取る
                responseType: 'arraybuffer'
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;

                    // レスポンス結果のバイナリデータが存在する場合、zipファイルを作成する
                    if (response.data) {
                        // レスポンス結果のバイナリデータをBlobオブジェクトにする
                        const blob = new Blob([response.data]);

                        // BlobオブジェクトのURLオブジェクトを作成する
                        const objURL: string = window.URL.createObjectURL(blob);

                        // エレメントを作成し、要素にURLオブジェクトとダウンロードするファイル名を格納する
                        const dlLink: HTMLAnchorElement = document.createElement('a');
                        dlLink.href = objURL;
                        dlLink.download = fileName;

                        // 親のHTMLのbody要素に子ノードを追加し、作成した要素を追加する
                        document.body.appendChild(dlLink);

                        // 追加した子ノードの要素に対してクリックイベントを起こし、ファイルをダウンロードする
                        dlLink.click();

                        // 子ノードを削除する
                        document.body.removeChild(dlLink);
                    }
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;

                    // ArrayBuffer型のエラーメッセージデータを16進数の文字コードの配列に変換する
                    const errorMessage = Array.from(new Uint8Array(error.response.data));

                    // 作成した文字コードを文字列に変換し、JSON形式に変換する
                    result.data =  JSON.parse(String.fromCharCode.apply('', errorMessage));
                });

            // 通信結果を返す
            return result;
        }
    }
}
